function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Link from 'shared/components/Link';
import { T } from 'shared/helper/translate';
import RubriqLoadingSpinner from '../../components/RubriqLoadingSpinner';
import { loadCriteriaWizardSession, saveTemplateSession } from '../../actions';
import RubriqTemplateResponseItem from './RubriqTemplateResponseItem';
import RubriqAbstractToolbar from './RubriqAbstractToolbar';
import RubriqGlobalWordCount from './RubriqGlobalWordCount';
var RubriqTemplate = function RubriqTemplate() {
  var _criteriaResponses$te;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    userTemplateResponses = _useState4[0],
    setUserTemplateResponses = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    responsesSaved = _useState6[0],
    setResponsesSaved = _useState6[1];
  var _useParams = useParams(),
    sessionIdentity = _useParams.sessionIdentity;
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    criteriaResponses = _useSelector.curie.abstractWriter.criteriaResponses;
  var _ref = (_criteriaResponses$te = criteriaResponses['text-limit']) !== null && _criteriaResponses$te !== void 0 ? _criteriaResponses$te : {
      useCharacters: false
    },
    useCharacters = _ref.useCharacters;
  var dispatch = useDispatch();

  // load session
  useEffect(function () {
    dispatch(loadCriteriaWizardSession(sessionIdentity)).then(function (json) {
      setLoading(false);
      setUserTemplateResponses(json.templateResponses);
    });
  }, []);

  // TODO: implement a more comprehensive save feature (autosave)
  var saveResponses = useCallback(function () {
    if (!userTemplateResponses) {
      return;
    }
    dispatch(saveTemplateSession({
      sessionIdentity: sessionIdentity,
      templateResponses: userTemplateResponses
    }));
    setResponsesSaved(true);
  }, [userTemplateResponses]);
  if (loading) {
    return /*#__PURE__*/React.createElement(RubriqLoadingSpinner, null);
  }
  var handleChangedResponse = function handleChangedResponse(prompt, response) {
    setUserTemplateResponses(_objectSpread(_objectSpread({}, userTemplateResponses), {}, _defineProperty({}, prompt, response)));
    setResponsesSaved(false);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RubriqAbstractToolbar, null), /*#__PURE__*/React.createElement("div", {
    className: "mt-4 d-flex justify-content-between align-items-center pb-2 border-bottom"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "fs-5 fw-semibold m-0"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.template"
  })), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary",
    onClick: saveResponses
  }, "Save"), /*#__PURE__*/React.createElement(Link, {
    to: "/rubriq/abstract-writer/".concat(sessionIdentity, "/review"),
    className: "btn btn-primary"
  }, /*#__PURE__*/React.createElement(T, {
    source: "curie.review-abstract"
  }))), Object.keys(userTemplateResponses).map(function (prompt) {
    return /*#__PURE__*/React.createElement(RubriqTemplateResponseItem, {
      key: "template-".concat(prompt),
      initialEditorState: userTemplateResponses[prompt],
      questionText: prompt,
      handleChange: handleChangedResponse,
      saved: responsesSaved,
      useCharacters: useCharacters
    });
  }), /*#__PURE__*/React.createElement("div", {
    className: "pt-3 mt-3"
  }, /*#__PURE__*/React.createElement(RubriqGlobalWordCount, null)));
};
export default RubriqTemplate;